<script setup>
// Sprint AGENDAR-MSG (15/07/2026): chip discreto acima do composer avisando que
// existem mensagens agendadas nesta conversa. Click abre o modal em modo lista.
// Sprint AGENDAR-MSG.1: mostra o template quando o agendamento e por template.
//
// Sem o chip o agendamento vira caixa-preta: o operador nao saberia que existe
// algo na fila nem como cancelar (mesma classe de falha silenciosa das
// armadilhas #39/#46).
import { computed } from 'vue';
import { useStore } from 'vuex';

const props = defineProps({
  conversationId: { type: [Number, String], required: true },
});
const emit = defineEmits(['open']);

const store = useStore();

const pending = computed(
  () => store.getters['bmtScheduledMessages/pendingByConv'][props.conversationId] || []
);

const pad = n => String(n).padStart(2, '0');

const next = computed(() => pending.value[0] || null);

const nextAt = computed(() => {
  if (!next.value) return '';
  const d = new Date(next.value.scheduled_at);
  if (Number.isNaN(d.getTime())) return '';
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
});

const label = computed(() =>
  pending.value.length === 1
    ? '1 mensagem agendada'
    : `${pending.value.length} mensagens agendadas`
);
</script>

<template>
  <button
    v-if="pending.length"
    class="flex items-center gap-1.5 w-full px-3 py-1.5 text-xs border-b border-slate-100 dark:border-slate-700 bg-emerald-50 dark:bg-emerald-900/20 text-emerald-800 dark:text-emerald-300 hover:bg-emerald-100 dark:hover:bg-emerald-900/40"
    @click="emit('open')"
  >
    <span class="i-lucide-clock size-3.5 shrink-0" />
    <span class="font-medium">{{ label }}</span>
    <span class="text-emerald-600 dark:text-emerald-400">· {{ nextAt }}</span>
    <span
      v-if="next && next.has_template"
      class="text-emerald-600 dark:text-emerald-400 truncate"
    >
      · template {{ next.template_name }}
    </span>
    <span class="ml-auto font-medium underline shrink-0">ver / cancelar</span>
  </button>
</template>
